/**
 * @generated SignedSource<<6449de2bb51ffb2b78a9ec33a940c1e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespSearchResultContainer_user$data = {
  readonly hasMerchandizingPermission: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedAuctionItemsBanner_user" | "SharedItemTile_user" | "useMeasurementUnit_user">;
  readonly " $fragmentType": "SbRespSearchResultContainer_user";
};
export type SbRespSearchResultContainer_user$key = {
  readonly " $data"?: SbRespSearchResultContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespSearchResultContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespSearchResultContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "hasMerchandizingPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "BUYER_FE_MERCH_TOOL"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedAuctionItemsBanner_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1dd908a50a0a1839aac48a852ce32d9d";

export default node;
